import { render, staticRenderFns } from "./LangageAgentConfig.vue?vue&type=template&id=4d4d1fbf&scoped=true&"
import script from "./LangageAgentConfig.vue?vue&type=script&lang=js&"
export * from "./LangageAgentConfig.vue?vue&type=script&lang=js&"
import style0 from "./LangageAgentConfig.vue?vue&type=style&index=0&id=4d4d1fbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d1fbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VTextarea})
